export default "__VITE_ASSET__QaL2vbks__ 1034w, __VITE_ASSET__2poEXlPN__ 767w, __VITE_ASSET__A3F26G_Q__ 500w";